<template>
  <div id="mypage-myinfo-template">
    <div class="relative">
      <h3 class="underbar-middle-title">내 정보 수정</h3>
      <div class="title-edit-btn-group title-edit-btn-group--bottom-20">
        <a href="mypage-password.do" class="btn--light-gray--blue xs-btn">비밀번호 변경</a>
      </div>
    </div>
    <div class="basic-form">
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">이름</label>
        <p class="progress__only-text">{{member.name}}</p>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">생년월일</label>
        <p class="progress__only-text">{{member.birthdate}}</p>
      </div>
      <div class="inline-input-group clearfix" v-if="member.roleManager.indexOf('ROLE_JB_ACTIVITY') > -1">
        <label class="inline-input__label">서명사진 </label>
        <img v-if="member.photoSignUrl" :src="member.photoSignUrl" alt="서명 사진" class="file-uploads-thumb">
        <label>* 사이즈는 세로 56px, 가로 113px 입니다.</label>
        <form name="signform" id="signform" method="post" enctype="multipart/form-data" action="/api/file-uploads/fileUploadSign.do">
          <input type="file" name="file" class="inline-input__file" id="mySign" v-on:change="imgSignUrlChange('mySign')" title="mySign 첨부파일 선택">
        </form>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">성별</label>
        <label class="radio-inline label__radio" v-for="(key, value) in gender">
          <input type="radio" name="inlineRadioOptions" v-model="member.gender" :value="value" title="{{key}} 선택"> {{key}}
        </label>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">아이디</label>
        <p class="progress__only-text">{{member.loginid}}</p>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label" for="hpFirst">휴대폰</label>
        <div class="f-gutter-10">
          <div class="f-gutter-10__li grid-3">
            <select class="input__select" v-model="member.phone1" id="hpFirst" title="휴대폰 앞번호">
              <option value="010">010</option>
              <option value="011">011</option>
              <option value="016">016</option>
              <option value="017">017</option>
              <option value="018">018</option>
              <option value="019">019</option>
            </select>
          </div>
          <div class="f-gutter-10__li grid-3">
            <input type="text" name="" v-model="member.phone2" class="input__text" placeholder="입력해주세요" title="휴대폰 중간번호">
          </div>
          <div class="f-gutter-10__li grid-3">
            <input type="text" name="" v-model="member.phone3" class="input__text" placeholder="입력해주세요" title="휴대폰 뒷번호">
          </div>
        </div>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">이메일</label>
        <div class="f-gutter-10">
          <div class="f-gutter-10__li grid-4">
            <input type="text" name="" v-model="email1" class="input__text" placeholder="입력해주세요" title="이메일 계정">
          </div>
          <div class="f-gutter-10__li grid-10 text-center">@</div>
          <div class="f-gutter-10__li grid-4">
            <select class="input__select" id="emailSelectBox" v-model="email2" v-on:change="emailChange" title="이메일 도메인 선택">
              <option v-for="list in emailList" :value="list">{{list}}</option>
              <option value="etc">직접입력</option>
            </select>
          </div>
          <div class="f-gutter-10__li grid-4">
            <input type="text" name="" id="emailSelectBoxDirect" class="input__text" style="display: none;" v-model="etcEmailAddress" placeholder="입력해주세요" title="이메일 도메인(직접입력)">
          </div>
        </div>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label" for="postcode">주소</label>
        <div class="f-gutter-10">
          <div class="f-gutter-10__li grid-2">
            <input type="text" name="" class="input__text" id="postcode" placeholder="입력해주세요" v-model="member.zipcode" readonly title="우편번호">
          </div>
          <div class="f-gutter-10__li grid-2">
            <button class="xs-btn btn--gray" id="findPostCode" @click="findAddress">우편번호 검색</button>
          </div>
          <div class="f-gutter-10__li">
            <div id="wrap" style="display:none;border:1px solid;width:500px;height:300px;margin:5px 0;position:relative; overflow: hidden;">
              <img src="//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" id="btnFoldWrap" style="cursor:pointer;position:absolute;right:0px;top:-1px;z-index:1" alt="접기 버튼" @click="foldDaumPostcode">
            </div>
          </div>
        </div>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label"></label>
        <div class="f-gutter-10">
          <div class="f-gutter-10__li grid-2">
            <input type="text" name="" v-model="member.addr1" class="input__text" placeholder="입력해주세요" readonly title="기본주소">
          </div>
          <div class="f-gutter-10__li grid-2">
            <input type="text" name="" v-model="member.addr2" class="input__text" placeholder="입력해주세요" v-on:keyup="checked" title="상세주소">
          </div>
        </div>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label" >가입경로</label>
        <select class="input__select" id="joinChannel" v-model="channel"  v-on:change="channelChange" title="joinChannel 선택">
          <option value="지인소개">지인소개</option>
          <option value="50+재단/캠퍼스/센터">50+재단/캠퍼스/센터</option>
          <option value="서울시 유관홈페이지">서울시 유관홈페이지</option>
          <option value="언론보도">언론보도(신문, 방송, 라디오 등)</option>
          <option value="옥외광고">옥외광고(지하철, 버스, 현수막 등)</option>
          <option value="타 기관 안내">타 기관 안내</option>
          <option value="홍보책자">홍보책자(포스터, 전단지, 리플릿 등)</option>
          <option value="인터넷/SNS 검색">인터넷/SNS 검색(페이스북 등)</option>
          <option value="미디어광고">미디어광고(신문잡지, 라디오광고 등)</option>
          <option value="etc">기타</option>
        </select>
        <input type="text" name="" v-model="channelEtc" id="joinChannelEtc" class="input__text margin-top-10" style="display:none;" v-on:keyup="checked" maxlength="30" placeholder="입력해주세요." title="가입경로">
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">가입동기 및<br/> 희망분야</label>
        <select class="input__select" v-model="motive" id="joinMotive" v-on:change="motiveChange" title="joinMotive 선택">
          <option value="인생후반전 준비에 대한 인식을 가지고자">인생후반전 준비에 대한 인식을 가지고자</option>
          <option value="사회공헌 및 자원봉사에 관심이 있어서">사회공헌 및 자원봉사에 관심이 있어서</option>
          <option value="NGO 등 인생후반전을 위한 단체를 구성하기 위해서">NGO 등 인생후반전을 위한 단체를 구성하기 위해서</option>
          <option value="창업을 위해서">창업을 위해서</option>
          <option value="재취업을 위해서">재취업을 위해서</option>
          <option value="생각이나 취미가 같은 사람들을 만나기 위해">생각이나 취미가 같은 사람들을 만나기 위해</option>
          <option value="etc">기타</option>
        </select>
        <input type="text" name="" v-model="motiveEtc" id="joinMotiveEtc" class="input__text margin-top-10" style="display:none;" v-on:keyup="checked" maxlength="30" placeholder="입력해주세요." title="가입동기 및 희망분야">
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label" for="myProfile">사진</label>
        <img v-if="member.photoUrl" :src="member.photoUrl" alt="프로필 사진" class="file-uploads-thumb">
        <form name="profileform" id="profileform" method="post" enctype="multipart/form-data" action="/api/file-uploads">
          <input type="file" name="file" class="inline-input__file" id="myProfile" v-on:change="imgUrlChange('myProfile')" title="사진">
        </form>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">나의 관심 50+</label>
        <label class="checkbox-inline label__radio">
          <input class="input__checkbox" type="checkbox" v-model="allCheck" name="inlineRadioOptions" @click="chkAllOrgs" id="like-orgs" title="전체 선택"> 전체
        </label>
        <label class="checkbox-inline label__radio" v-for="org in orgList">
          <template  v-if="org.code !== 'fpp'">
          <input class="input__checkbox" v-model="member.likeOrgs" type="checkbox" name="inlineRadioOptions" id="" :value="org.code" title="{{org.name}} 선택"> {{org.name}}
          </template>
        </label>
        <p class="helper-text">* 관심 50+ 기관의 소식(문자, 뉴스레터)을 받을 수 있습니다.</p>
      </div>
      <div class="inline-input-group clearfix">
        <p class="inline-input__label"> 주된 직업군</p>
        <label class="checkbox-inline label__radio" v-for="occu in occuList">
          <input class="input__checkbox" type="checkbox" :value="occu" v-model="member.occuPation" name="occuPationName" @click="onClick(occu)" title="{{occu}} 선택"> {{occu}}
          <span v-if="occu === '기타'">(<input type="text" size="12" maxlength="12" id="occuEtc" v-model="occuEtcVal" v-on:keyup="checked" title="주된 직업군 기타 입력란">)</span>
        </label>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">Email 수신</label>
        <label class="radio-inline label__radio" v-for="(key, value) in emailCheck">
          <input type="radio" name="inlineRadioOptions1" id="emailChk" v-model="member.emailCheck" :value="value" title="{{key}} 선택"> {{key}}
        </label>
      </div>
      <div class="inline-input-group clearfix">
        <label class="inline-input__label">SMS 수신</label>
        <label class="radio-inline label__radio" v-for="(key, value) in smsCheck">
          <input type="radio" name="inlineRadioOptions2" id="smsCheck" v-model="member.smsCheck" :value="value" title="{{key}} 선택"> {{key}}
        </label>
      </div>
    </div>
    <div class="text-center">
      <button type="button" class="form-submit__btn btn--blue-line" @click="updateInfo">수정하기</button>
    </div>
    <div class="text-right">
      <button type="button" class="withdraw-btn" @click="addAuth" style="margin-right: 2%;" v-if="member.memberAuthSize == 0">간편인증 등록하기</button>
      <button type="button" class="withdraw-btn" @click="delAuth" style="margin-right: 2%;" v-if="member.memberAuthSize > 0">간편인증 삭제하기</button>
      <button type="button" class="withdraw-btn" @click="slCan" style="margin-right: 2%;" >연계철회하기</button>
      <button type="button" class="withdraw-btn" @click="showWithdrewModal">탈퇴하기</button>
    </div>
    <form id="myEduForm" name="myEduForm" method="post" action="/slMemberLinkReqCancel">
      <input type="hidden" name="instCd" id="instCd" value="B55366"/><!-- 평생학습포털 서울런4050 행정표준기관 코드 -->
    </form>
    <withdrew-modal :showModal.sync="showModal"></withdrew-modal>
  </div>
</template>
<script>
  /* global daum */
  import axios from 'axios';
  import WithdrewModal from './WithdrewModal.vue';

  const occuList = [
    '경영/금융/사무/보험',
    '공무원(교사)',
    '교육/강사/연구/법률',
    '의료/보건/사회복지',
    '마케팅/무역',
    '전문직(의사/변호사 등)',
    '문화/예술/신문방송/디자인',
    '영업/판매/고객상담/CS',
    '건설/건축/환경/산업',
    'IT/정보통신/웹',
    '숙박/음식/여행/스포츠/경비청소',
    '전업주부',
    '무직',
    '기타',
  ];

  const gender = {
    M: '남성',
    F: '여성',
  };

  const emailCheck = {
    Y: '수신',
    N: '거부',
  };

  const smsCheck = {
    Y: '수신',
    N: '거부',
  };

  const emailList = [
    'naver.com',
    'hanmail.net',
    'daum.net',
    'gmail.com',
    'google.com',
    'nate.com',
    'yahoo.com',
    'paran.com',
    'korea.com',
    'freechal.com',
  ];


  const joinPurpose = [
    '인생후반전 준비에 대한 인식을 가지고자',
    '사회공헌 및 자원봉사에 관심이 있어서',
    'NGO 등 인생후반전을 위한 단체를 구성하기 위해서',
    '창업을 위해서',
    '재취업을 위해서',
    '생각이나 취미가 같은 사람들을 만나기 위해',
  ];
  const applyPath = [
    '서울시 유관홈페이지',
    '언론보도',
    '홍보책자',
    '옥외광고',
    '미디어광고',
    '인터넷/SNS 검색',
    '타 기관 안내',
    '50+재단/캠퍼스/센터',
    '지인소개',
  ];
  export default {
    name: 'mypage-myinfo-template',
    props: ['member', 'orgList', 'orgCode'],
    components: {
      WithdrewModal,
    },
    data() {
      return {
        emailList,
        joinPurpose,
        applyPath,
        etcEmailAddress: '',
        allCheck: false,
        motive: '',
        channel: '',
        email1: '',
        showModal: false,
        email2: '',
        channelEtc: '',
        motiveEtc: '',
        gender,
        occuPation: [],
        occuPationStr: '',
        occuList,
        occuEtcVal: '',
        emailCheck,
        smsCheck,
      };
    },
    computed: {

    },
    watch: {
    },
    methods: {
      checked(event) {
        if (event.key === "'") {
          alert("'는 사용 하실 수 없습니다.");
          this.channelEtc = this.channelEtc.replace("'", '');
          this.motiveEtc = this.motiveEtc.replace("'", '');
          this.occuEtcVal = this.occuEtcVal.replace("'", '');
          this.member.addr2 = this.member.addr2.replace("'", '');
        }
      },
      onClick(obj) {
        if (this.occuPationStr === obj) {
          this.member.occuPation = [];
          this.occuPation = [];
          this.occuPationStr = '';
        } else {
          this.member.occuPation = [obj];
          this.occuPation = [obj];
          this.occuPationStr = obj;
        }
      },
      updateInfo() {
        if (!this.email2 || !this.email1) {
          alert('이메일을 입력해 주세요.');
        } else if (!this.member.phone1 || !this.member.phone2 || !this.member.phone3) {
          alert('연락처를 입력해 주세요.');
        } else if (!this.member.zipcode || !this.member.addr1 || !this.member.addr2) {
          alert('주소를 입력해 주세요.');
        } else if (!this.channel || (this.channel === 'etc' && !this.channelEtc)) {
          alert('가입경로를 입력해 주세요.');
        } else if (!this.motive || (this.motive === 'etc' && !this.motiveEtc)) {
          alert('가입동기 및 희망분야를 입력해 주세요.');
        } else if (this.member.likeOrgs.length === 0) {
          alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
          $('#like-orgs').focus();
        } else if (!this.member.emailCheck) {
          alert('이메일 수신여부를 선택해주십시오.');
        } else if (!this.member.smsCheck) {
          alert('문자메시지 수신여부를 선택해주십시오.');
        } else {
          const email2 = this.email2 !== 'etc' ? this.email2 : this.etcEmailAddress;
          const channel = this.channel !== 'etc' ? this.channel : this.channelEtc;
          const motive = this.motive !== 'etc' ? this.motive : this.motiveEtc;
          const mail = `${this.email1}@${email2}`;
          const etc = this.occuPationStr.substring(0, 2);
          if (etc === '기타') {
            const front = '기타(';
            const end = ')';
            this.occuPationStr = front + document.getElementById('occuEtc').value + end;
            this.occuEtcVal = document.getElementById('occuEtc').value;
          }
          if (this.occuPationStr === '') {
            this.occuPationStr = this.member.occuPation.toString();
          }

          const Params = {
            email: mail,
            birthdate: this.member.birthdate,
            phone1: this.member.phone1,
            phone2: this.member.phone2,
            phone3: this.member.phone3,
            zipcode: this.member.zipcode,
            addr1: this.member.addr1,
            addr2: this.member.addr2,
            gender: this.member.gender,
            applyPath: channel,
            joinPurpose: motive,
            likeOrgs: this.member.likeOrgs,
            photoSignUrl: this.member.photoSignUrl,
            photoUrl: this.member.photoUrl,
            occuPation: this.occuPationStr,
            emailCheck: this.member.emailCheck,
            smsCheck: this.member.smsCheck,
          };
          axios.put('/api/members/info', Params).then(() => {
            alert('저장되었습니다.');
            location.reload();
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      imgSignUrlChange() {
        $('#signform').ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              this.member.photoSignUrl = response.filename;
              if (response.filename === 'false') {
                alert('사진의 가로와 세로 길이를 확인해 주세요.');
                document.getElementById('mySign').value = '';
                this.member.photoSignUrl = '';
              } else {
                this.member.photoSignUrl = response.filename;
              }
            } else {
              alert(statusText);
            }
          },
        });
      },
      imgUrlChange() {
        const that = this;
        $('#profileform').ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              that.member.photoUrl = response.filename;
            } else {
              alert(statusText);
            }
          },
        });
      },
      motiveValue() {
        const purpose = this.joinPurpose.filter(item => item === this.member.joinPurpose);
        if (purpose && purpose.length > 0) {
          this.motive = this.member.joinPurpose;
        } else {
          this.motive = 'etc';
          this.motiveEtc = this.member.joinPurpose;
        }
      },
      channelValue() {
        const route = this.applyPath.filter(item => item === this.member.applyPath);
        if (route && route.length > 0) {
          this.channel = this.member.applyPath;
        } else {
          this.channel = 'etc';
          this.channelEtc = this.member.applyPath;
        }
      },
      emailValue() {
        this.email1 = this.member.email.split('@')[0];
        const emailAddress = this.member.email.split('@')[1];
        let isSame = false;
        emailList.forEach((item) => {
          if (item === emailAddress) isSame = true;
          else if (item !== emailAddress) {
            this.etcEmailAddress = emailAddress;
          }
        });
        if (isSame) this.email2 = emailAddress;
        else this.email2 = 'etc';
      },
      motiveChange() {
        if (this.motive === 'etc') {
          document.getElementById('joinMotiveEtc').style.display = 'block';
        } else {
          document.getElementById('joinMotiveEtc').style.display = 'none';
        }
      },
      emailChange() {
        if (this.email2 === 'etc') {
          document.getElementById('emailSelectBoxDirect').style.display = 'block';
        } else {
          document.getElementById('emailSelectBoxDirect').style.display = 'none';
        }
      },
      channelChange() {
        if (this.channel === 'etc') {
          document.getElementById('joinChannelEtc').style.display = 'block';
        } else {
          document.getElementById('joinChannelEtc').style.display = 'none';
        }
      },
      chkAllOrgs() {
        if (this.allCheck) {
          this.orgCode.forEach((item) => {
            this.member.likeOrgs.push(item);
          });
        } else {
          this.member.likeOrgs = [];
        }
      },
      foldDaumPostcode() {
        const elementWrap = document.getElementById('wrap');
        // iframe을 넣은 element를 안보이게 한다.
        elementWrap.style.display = 'none';
      },
      findAddress() {
        const thisVal = this;
        const elementWrap = document.getElementById('wrap');
        // 현재 scroll 위치를 저장해놓는다.
        const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        daum.postcode.load(() => {
          new daum.Postcode({
            oncomplete(data) {
              // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

              // 각 주소의 노출 규칙에 따라 주소를 조합한다.
              // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
              let fullAddr = data.address; // 최종 주소 변수
              let extraAddr = ''; // 조합형 주소 변수

              // 기본 주소가 도로명 타입일때 조합한다.
              if (data.addressType === 'R') {
                // 법정동명이 있을 경우 추가한다.
                if (data.bname !== '') {
                  extraAddr += data.bname;
                }
                // 건물명이 있을 경우 추가한다.
                if (data.buildingName !== '') {
                  extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
                }
                // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
                fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
              }

              // 우편번호와 주소 정보를 해당 필드에 넣는다.
              // 5자리 새우편번호 사용
              // document.getElementById('postcode').value = data.zonecode;
              thisVal.member.addr1 = fullAddr;
              thisVal.member.zipcode = data.zonecode;

              // iframe을 넣은 element를 안보이게 한다.
              // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
              elementWrap.style.display = 'none';

              // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
              document.body.scrollTop = currentScroll;
            },
            // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
            onresize(size) {
              elementWrap.style.height = `${size.height}px`;
            },
            width: '100%',
            height: '100%',
          }).embed(elementWrap);
        });
        // iframe을 넣은 element를 보이게 한다.
        elementWrap.style.display = 'block';
      },
      showWithdrewModal() {
        $('body').addClass('modal-open');
        this.showModal = true;
      },
      occuPationEtc() {
        const str = this.member.occuPation.toString();
        const etc = str.substring(0, 2);
        if (etc === '기타') {
          const left = str.indexOf('(');
          const right = str.indexOf(')');
          const sub = str.substring(left, right);
          const len = sub.length;
          const subPlus = sub.substring(1, len);
          document.getElementById('occuEtc').value = subPlus;
          this.occuEtcVal = subPlus;
          this.member.occuPation = [etc];
          this.occuPationStr = etc;
        }
      },
      slCan() {
        const result = window.confirm('서울시평생학습포털 회원정보와 연계를 철회하시겠습니까?');
        if (result) {
          $('#myEduForm').ajaxSubmit({
            dataType: 'json',
            error: (err) => {
              alert(err.msg);
            },
            success: (response, statusText) => {
              if (statusText === 'success') {
                alert('연계가 철회 되었습니다.');
              }
            },
          });
        }
      },
      addAuth() {
        const loginId = this.member.loginid;
        if (!loginId.includes('anyId')) {
          alert('준비중입니다.');
          return;
        }
        const result = window.confirm('간편인증 정보를 등록하시겠습니까?');
        if (result) {
          window.anyidAdaptor.ssoLoginPage('/api/members/addAuth', '3');
        }
      },
      delAuth() {
        const loginId = this.member.loginid;
        if (!loginId.includes('anyId')) {
          alert('준비중입니다.');
          return;
        }
        const result = window.confirm('간편인증 정보를 삭제하시겠습니까?');
        if (result) {
          axios.post('/api/members/delAuth', {
          }).then(() => {
            alert('삭제를 완료했습니다.');
            location.reload();
          }).catch((error) => {
            alert(error.response.data.msg);
          });
        }
      },
    },
    mounted() {
      this.emailValue();
      this.motiveValue();
      this.channelValue();
      this.motiveChange();
      this.channelChange();
      this.emailChange();
      this.occuPationEtc();

      console.log('memberAuth의 키들:', this.member.memberAuthSize);
    },
  };
</script>


// WEBPACK FOOTER //
// MyPageInfo.vue?ea1b8930